import { styled } from "@mui/material";
import { StyledCard } from "../styledCard.styled";

type StyledProjectDataProps = {
  editMode: boolean;
};

export const StyledProjectData = styled(StyledCard)<StyledProjectDataProps>(
  ({ theme, editMode }) => ({
    gridArea: "8 / 1 / 14 / 2",
    ".content": {
      paddingInline: "2rem",
      display: "flex",
      flexDirection: "column",
      gap: editMode ? ".25rem" : ".5rem",
      justifyContent: "space-between",
      height: "100%",
      ".row": {
        display: "flex",
        width: "100%",
        minHeight: "2rem",
        alignItems: "center",
        gap: "2rem",
        ".contactInfo": {
          minWidth: "5rem",
        },
        h4: {
          color: theme.contrast.dark,
          fontWeight: "600",
        },
      },
      ".hours": {
        gap: "0",
        justifyContent: "space-between",
        paddingRight: "5rem",
        boxSizing: "border-box",
        "& .MuiInputBase-input": {
          width: "2rem",
        },
      },
    },
    "& .MuiOutlinedInput-root": {
      border: `2px solid ${theme.color.dark}`,
      width: "100%",
    },
    [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {
      paddingBottom: "0",
    ".content": {
      paddingInline: "1rem",
      overflowY: "auto",
      justifyContent: "space-evenly",
      ".row": {
        display: "flex",
        width: "100%",
        minHeight: "2rem",
        alignItems: "center",
        gap: "2rem",
        ".contactInfo": {
          minWidth: "5rem",
        },
        h4: {
          color: theme.contrast.dark,
          fontWeight: "600",
        },
      },
      ".hours": {
        gap: "0",
        justifyContent: "space-between",
        paddingRight: "5rem",
        boxSizing: "border-box",
        "& .MuiInputBase-input": {
          width: "2rem",
        },
      },
    },
    ".head": {
      marginBottom: "0",
      padding: ".25rem 1rem",
      h3: {
        fontSize: "1.2rem",
      },
      svg: {
        width: "24px"
      },
    },
  },
  })
);
